import { useCallback, useEffect, useState } from 'react';

export function useCountDown(
  initialSeconds: number
): [number, (seconds: number) => void] {
  const [endTime, setEndTime] = useState<number | null>(
    Date.now() + initialSeconds * 1000
  );
  const [timeLeft, setTimeLeft] = useState(initialSeconds);

  const startCountdown = useCallback((seconds: number) => {
    if (seconds <= 0) {
      setEndTime(null);
      setTimeLeft(0);
    } else {
      setEndTime(Date.now() + seconds * 1000);
      setTimeLeft(seconds);
    }
  }, []);

  useEffect(() => {
    if (!endTime) {
      setTimeLeft(0);
      return;
    }
    const interval = setInterval(() => {
      const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      setTimeLeft(remaining);
      if (remaining <= 0) setEndTime(null);
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);

  return [timeLeft, startCountdown];
}
